export default __webpack_public_path__ + "static/media/phoneen.cbab4b34.png";